(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfKeyboardTableNav', function() {
    return {
      restrict: 'A',
      link: function(scope, ele, attrs) {
        var KEYS, focusOnEle;
        KEYS = {
          up: 38,
          down: 40,
          enter: 13
        };
        focusOnEle = function(e, cb) {
          var $target, columnNumber, columns, nextColumn, nextRow, parent, row;
          e.preventDefault();
          $target = $(e.target);
          parent = $target.parent('td')[0];
          row = $target.parents('tr');
          columns = $.makeArray(row.find('td'));
          columnNumber = columns.indexOf(parent);
          nextRow = cb(row);
          nextColumn = nextRow.find('td').eq(columnNumber);
          return nextColumn.find('input').focus();
        };
        return ele.on('keydown', function(e) {
          switch (e.keyCode) {
            case KEYS.up:
              return focusOnEle(e, function(row) {
                return row.prev();
              });
            case KEYS.down:
            case KEYS.enter:
              return focusOnEle(e, function(row) {
                return row.next();
              });
          }
        });
      }
    };
  });

}).call(this);
